/*
 *地图容器组件
 * @module components/mapbase/OlBaseMap
 * @desc 用于展示地图
 * @author zhaoting
 * @date 2019年12月16日
 * @param {Array} [center]    - 地图默认中心坐标
 * @param {Number} [zoom]     - 地图缩放级别
 */
import Vue from 'vue';
import Cookies from 'js-cookie';
import MapTools from '../maptools/MapTools.vue';
import MapToolTip from './MapTooTip.vue';
import MapVideoTip from './MapVideoTip.vue';
import MapdetailTip from './MapdetailTip.vue';
import appConfig from 'appConfig';
import detailItem from './detailItem/detailItem.vue';
import { deletemidea, findListFileBySys, insertArchivesManage, getJSONByCode } from '@/api/index';

export default {
  name: '',
  components: {
    MapTools,
    MapToolTip,
    MapVideoTip,
    MapdetailTip,
  },
  events: {},
  props: {
    center: {
      type: Array,
      default: () => [],
    },
    zoom: {
      type: Number,
      default: 0,
    },
    mapId: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => {},
    },
    isScale: {
      type: Boolean,
      default: false,
    },
    tagertId: {
      type: String,
      default: '',
    },
    showTool: {
      type: Boolean,
      default: true,
    },
    isChangeMap: {
      type: Boolean,
      default: true,
    },
    isSwitchMap: {
      type: Boolean,
      default: true,
    },
    switchMapPosition: {
      type: String,
      default: 'rb', //lt lb rt rb
    },
    isAddLayerisAddLayer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      convertor: null,
      uploadHeader: { accessToken: Cookies.get('accessToken') },
      zIndex: 1000,
      map: {},
      configMap: {},
      baseMapLayer: null,
      baseMapImgLayer: null,
      homePageLayer: null,
      baseMapFontLayer: {},
      imageLayer: {},
      markLayer: {},
      modal1: false,
      modal2: false,
      environmentArr: {},
      feaData: {},
      videourl: '',
      username: '',
      columns_midea: [
        {
          title: '文件名',
          key: 'name',
          minWidth: 260,
          tooltip: true,
        },
        {
          title: '操作',
          key: 'action',
          width: 160,
          align: 'center',
          render: (h, params) => {
            var displayshow = {
              marginRight: '5px',
              display: 'inline',
            };
            if (!appConfig.isPdfDelete) {
              displayshow.display = 'none';
            } else {
              displayshow.display = 'inline';
            }

            return h('div', [
              h(
                'Button',
                {
                  props: {
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.showInfo_midea(params.row);
                    },
                  },
                },
                '查看'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: displayshow,
                  on: {
                    click: () => {
                      this.remove_midea(params.row);
                    },
                  },
                },
                '删除'
              ),
            ]);
          },
        },
      ],
      mideaModalVisible: false,
      loading: false, // 表单加载状态
      mideaInfo: [],
      pdfField: '', //档案管理字段
      uploadData: {
        paramStr: '',
      },
      projection: this.$olmap.proj.get(appConfig.map.proj),
      currentLayerInfo: null,
      isUploadPDF: false,
      uploadConfig: '/upload',
      isDocument: false,
      zindex: 400,
      selectLayerData: {},
      zoomNumber: 0, //地图的层级
      DrawingAndDocumentManagementId: '', // 图档管理选择树的id
      DrawingAndDocumentManagementFileId: '', // 图档管理属性唯一值
      mapPointsAll: [], //地图所有点的集合
      propImgArr: [], //选择的气泡的图片上数据集合
      imagesArr: [],
      selectFeaData: {},
    };
  },
  mounted() {
    Vue.prototype.olmap = undefined;
    this.initMap();
    this.sendGSJson();
    this.initMapClick();
    this.getUser();
    this.$bus.on('nowLayerData', data => {
      this.selectLayerData = data;
    });
    this.$bus.off('DrawingAndDocumentManagement');
    this.$bus.on('DrawingAndDocumentManagement', data => {
      this.DrawingAndDocumentManagementId = data;
    });
    this.$bus.off('DrawingAndDocumentManagementfileFieldId');
    this.$bus.on('DrawingAndDocumentManagementfileFieldId', data => {
      this.DrawingAndDocumentManagementFileId = data;
    });
    // 获取地图容器的当前层级
    this.zoomNumber = this.olmap.getView().getZoom();
    this.$bus.off('setOlbaseMapPoint');
    this.$bus.on('setOlbaseMapPoint', data => {
      this.mapPointsAll = data;
    });
  },
  created() {
    this.uploadConfig = this.publicMethod.appConfigBase.baseUpload;
    let roles =
      localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).roles;
    if (roles) {
      this.isUploadPDF = roles[0].isUploadPDF == null ? false : roles[0].isUploadPDF;
      this.isDocument = roles[0].isDocument == null ? false : roles[0].isDocument;
    }
    this.configMap = appConfig.map;
    this.zoomNumber = appConfig.map.zoom; //当前地图的层级
    window.previewImg = this.previewImg;
    window.goDetail = this.goDetail;
  },
  methods: {
    /**
     * 视频组件-子组件回调
     * @param {Boolean} [payload] -返回显示状态
     */
    parentvideoFn(payload) {
      //this.message = payload;
      this.modal1 = payload;
    },
    /**
     * 详细信息弹框组件-子组件回调
     * @param {Boolean} [payload] -返回显示状态
     */
    parentdetailFn(payload) {
      this.modal2 = payload;
    },
    /**
     * @author
     * @description 切换到三维地图
     */
    changemap() {
      this.$store.commit('setMapData', '3d');
      this.$layer.closeAll(); // 清除所有的layer弹框
      this.$emit('childFn', '3d');
    },

    //地图初始化
    initMap() {
      // 特殊空间参考注册
      var extent = [-180, -90, 180, 90];
      // proj4.defs("EPSG:4490","+proj=longlat +ellps=GRS80 +no_defs");
      //投影坐标系
      // 实例化鹰眼控件（OverviewMap），自定义其样式
      // var overviewMapControl = new ol.control.OverviewMap({
      //   className: 'ol-overviewmap ol-custom-overviewmap', //鹰眼控件样式
      //   collapseLabel: '\u00BB', //鹰眼控件展开时功能按钮上的标识
      //   label: '\u00AB', //鹰眼控件折叠时功能按钮上的标识
      //   collapsed: true, //初始为展开方式
      // });
      // this.projection = new this.$olmap.proj.Projection({ code: appConfig.map.proj, units: this.$olmap.proj.Units.METERS, extent: extent });
      proj4.defs(appConfig.map.proj, '+proj=longlat +ellps=GRS80 +no_defs');
      //投影坐标系
      this.projection = new this.$olmap.proj.Projection({
        code: this.configMap.proj,
        units: this.$olmap.proj.Units.METERS,
        extent: extent,
      });
      // var resolutions = appConfig.map.resolutions.reso;
      // this.map = new this.$olmap.Map({
      //   logo: false,
      //   target: this.tagertId,
      //   layers: [],
      //   view: new this.$olmap.View({
      //     center: [appConfig.map.center.lng, appConfig.map.center.lat],
      //     zoom: appConfig.map.zoom,
      //     projection: this.projection,
      //   }),
      //   // 加载鹰眼控件
      //   // controls: this.$olmap.control.defaults().extend([overviewMapControl]),
      // });
      // if (appConfig.map.isAddLayer) {
      //   // 添加底图-遍历配置文件底图
      //   if (appConfig.baseLayersConfig.vectorMap) {
      //     //影像底图
      //     var type = appConfig.baseLayersConfig.vectorMap.type;
      //     this.zindex++;
      //     switch (type) {
      //       case 'layer.ImageArcGISRest':
      //         this.baseMapLayer = this.publicMethod.getImageArcGISRest(
      //           appConfig.baseLayersConfig.vectorMap,
      //           this.zindex,
      //           this.$olmap
      //         );
      //         break;
      //       case 'layer.TileArcGISRestXYZ':
      //         this.baseMapLayer = this.publicMethod.getArcgisXYZTile(
      //           appConfig.baseLayersConfig.vectorMap,
      //           appConfig.map.origin,
      //           resolutions,
      //           this.zindex,
      //           this.$olmap,
      //           this.projection,
      //           [
      //             appConfig.map.extent.XMin,
      //             appConfig.map.extent.YMin,
      //             appConfig.map.extent.XMax,
      //             appConfig.map.extent.YMax,
      //           ]
      //         );
      //         break;
      //       case 'layer.TileArcGISRest':
      //         this.baseMapLayer = this.publicMethod.getTileArcGISRestLayer(
      //           appConfig.baseLayersConfig.vectorMap,
      //           appConfig.map.origin,
      //           resolutions,
      //           this.projection,
      //           this.$olmap,
      //           [
      //             appConfig.map.extent.XMin,
      //             appConfig.map.extent.YMin,
      //             appConfig.map.extent.XMax,
      //             appConfig.map.extent.YMax,
      //           ]
      //         );
      //         break;
      //       case 'layer.TileArcGISRestTD':
      //         this.baseMapLayer = this.publicMethod.getArcgisXYZTileTD(
      //           appConfig.baseLayersConfig.vectorMap,
      //           this.zindex,
      //           this.$olmap
      //         );
      //         break;
      //       default:
      //         break;
      //     }
      //     this.map.addLayer(this.baseMapLayer);
      //   }
      //   if (appConfig.baseLayersConfig.imageMap) {
      //     // 矢量底图
      //     var type = appConfig.baseLayersConfig.imageMap.type;
      //     this.zindex++;
      //     switch (type) {
      //       case 'layer.ImageArcGISRest':
      //         this.baseMapImgLayer = this.publicMethod.getImageArcGISRest(
      //           appConfig.baseLayersConfig.imageMap,
      //           this.zindex,
      //           this.$olmap
      //         );
      //         break;
      //       case 'layer.TileArcGISRestXYZ':
      //         this.baseMapImgLayer = this.publicMethod.getArcgisXYZTile(
      //           appConfig.baseLayersConfig.imageMap,
      //           appConfig.map.origin,
      //           resolutions,
      //           this.zindex,
      //           this.$olmap,
      //           this.projection,
      //           [
      //             appConfig.map.extent.XMin,
      //             appConfig.map.extent.YMin,
      //             appConfig.map.extent.XMax,
      //             appConfig.map.extent.YMax,
      //           ]
      //         );
      //         break;
      //       case 'layer.TileArcGISRest':
      //         this.baseMapImgLayer = this.publicMethod.getTileArcGISRestLayer(
      //           appConfig.baseLayersConfig.imageMap,
      //           appConfig.map.origin,
      //           resolutions,
      //           this.projection,
      //           this.$olmap,
      //           [
      //             appConfig.map.extent.XMin,
      //             appConfig.map.extent.YMin,
      //             appConfig.map.extent.XMax,
      //             appConfig.map.extent.YMax,
      //           ]
      //         );
      //         break;
      //       case 'layer.TileArcGISRestTD':
      //         this.baseMapImgLayer = this.publicMethod.getArcgisXYZTileTD(
      //           appConfig.baseLayersConfig.imageMap,
      //           this.zindex,
      //           this.$olmap
      //         );
      //         break;
      //       default:
      //         break;
      //     }
      //     this.map.addLayer(this.baseMapImgLayer);
      //   }
      //   if (appConfig.baseLayersConfig.vectorFontMap) {
      //     // 字体
      //     var type = appConfig.baseLayersConfig.vectorFontMap.type;
      //     this.zindex++;
      //     switch (type) {
      //       case 'layer.TileArcGISRestTD':
      //         this.baseMapFontLayer = this.publicMethod.getArcgisXYZTileTD(
      //           appConfig.baseLayersConfig.vectorFontMap,
      //           this.zindex,
      //           this.$olmap
      //         );
      //         break;
      //       case 'layer.ImageArcGISRest':
      //         this.baseMapFontLayer = this.publicMethod.getImageArcGISRest(
      //           appConfig.baseLayersConfig.vectorFontMap,
      //           this.zindex,
      //           this.$olmap
      //         );
      //         break;
      //       case 'layer.TileArcGISRestXYZ':
      //         this.baseMapFontLayer = this.publicMethod.getArcgisXYZTile(
      //           appConfig.baseLayersConfig.vectorFontMap,
      //           appConfig.map.origin,
      //           resolutions,
      //           this.zindex,
      //           this.$olmap,
      //           this.projection,
      //           [
      //             appConfig.map.extent.XMin,
      //             appConfig.map.extent.YMin,
      //             appConfig.map.extent.XMax,
      //             appConfig.map.extent.YMax,
      //           ]
      //         );
      //         break;
      //       default:
      //         break;
      //     }
      //     this.map.addLayer(this.baseMapFontLayer);
      //   }
      //   if (this.baseMapImgLayer) {
      //     this.baseMapImgLayer.setVisible(false);
      //   }
      //   if (appConfig.baseLayersConfig.homeMap) {
      //     this.homePageLayer = this.publicMethod.createGeoServerWMS(
      //       this.$olmap,
      //       appConfig.baseLayersConfig.homeMap,
      //       ++this.zindex
      //     );
      //     this.map.addLayer(this.homePageLayer);
      //   }
      // }
      this.convertor = new BMapGL.Convertor();
      window.BDMap = this.map = new BMapGL.Map(this.tagertId, {
        coordsType: 5, // coordsType指定输入输出的坐标类型，3为gcj02坐标，5为bd0ll坐标，默认为5。
        // 指定完成后API将以指定的坐标类型处理您传入的坐标
      }); // 创建地图实例
      var point = new BMapGL.Point(appConfig.map.center.lng, appConfig.map.center.lat); // 创建点坐标
      this.convertor.translate([point], 1, 5, data => {
        if (data.status === 0) {
          this.map.centerAndZoom(data.points[0], 7); // 初始化地图，设置中心点坐标和地图级别
        }
      });

      this.map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var dist = new BMapGL.DistrictLayer({
        name: '(甘肃省)',
        fillColor: '#c12c1f',
        fillOpacity: 0,
        strokeWeight: 2,
      });
      this.map.addDistrictLayer(dist);
      //关闭这个地图上的弹框
      this.map.zxClosePops = function() {
        var pops = this.zxPops;
        if (pops && pops.length > 0) {
          for (var i = 0; i < pops.length; i++) {
            pops[i].close();
          }
        }
      };
      //清除指定图层
      var that = this;
      this.map.clearLayer = function(item) {
        var layers = that.olmap.getLayers();
        var arrs = [];
        layers.forEach(function(sublayer) {
          if (sublayer != undefined && sublayer != null) {
            if (sublayer.getProperties() != undefined && sublayer.getProperties().id == item) {
              //关闭图层
              arrs.push(sublayer);
              return;
            }
          }
        });
        for (var i = 0; i < arrs.length; i++) {
          that.olmap.removeLayer(arrs[i]);
        }
      };
      //增加绘制图层
      this.map.zxDrawLayer = new this.$olmap.layer.Vector({
        id: '__draw',
        zIndex: 1002,
        source: new this.$olmap.source.Vector(),
        style: new this.$olmap.style.Style({
          //图层样式
          fill: new this.$olmap.style.Fill({
            color: 'rgba(255, 255, 255, 0.2)', //填充颜色
          }),
          stroke: new this.$olmap.style.Stroke({
            color: '#ffcc33', //边框颜色
            width: 2, // 边框宽度
          }),
        }),
      });
      //加载查询图层
      this.map.zxQueryLayer = new this.$olmap.layer.Vector({
        id: '__query',
        zIndex: 1005,
        source: new this.$olmap.source.Vector(),
        style: new this.$olmap.style.Style({
          stroke: new this.$olmap.style.Stroke({
            color: 'rgba(0, 0, 255, 1)',
            width: 2,
          }),
          fill: new this.$olmap.style.Fill({
            color: 'rgba(0, 0, 255, 0.1)', //填充颜色
          }),
        }),
      });
      // this.map.getTargetElement().style.cursor = 'pointer';
      this.map.addLayer(this.map.zxDrawLayer);
      this.map.setTarget(this.tagertId);
      this.map.addLayer(this.map.zxQueryLayer);
      this.map.projection = this.projection;
      // 实例化比例尺控件
      var scaleLineControl = new ol.control.ScaleLine({
        // 设置比例尺单位为degrees、imperial、us、nautical或metric（度量单位）
        units: 'metric',
        target: 'scalebar',
      });
      this.map.addControl(scaleLineControl);
      var mousePositionControl = new this.$olmap.control.MousePosition({
        coordinateFormat: ol.coordinate.createStringXY(4),
        projection: this.projection,
        className: 'custom-mouse-position',
        target: document.getElementById('mouse-position'),
        undefinedHTML: '&nbsp',
      });
      this.map.addControl(mousePositionControl);
      if (!Vue.prototype.olmap) Object.defineProperty(Vue.prototype, 'olmap', { value: this.map });
    },
    sendGSJson() {
      var param = {
        areaCode: '620000',
      };
      getJSONByCode(param).then(res => {
        if (res.code == 200 && res.success) {
          var location = [Number(appConfig.map.center.lng), Number(appConfig.map.center.lat)];
          this.map.getView().animate({
            center: location,
            duration: 1500,
            zoom: appConfig.map.GSZoom,
          });
          // 获取单独一个市的边界线
          var dataCity = res.result.cityMap.features;
          dataCity.forEach(item => {
            var polygonProvice = this.publicMethod.createLayerLine(ol, item, '#ff0000', '620000');
            this.map.addLayer(polygonProvice);
            polygonProvice.setZIndex(996);
          });
        }
      });
    },
    //地图鼠标点击事件
    initMapClick() {
      /*** 鼠标点击的事件 -地图图层要素属性查询*/
      var that = this;
      this.map.on('click', function(evt) {
        // 判断是否是测量或者绘制阶段
        if (that.olmap.drawOpt) {
          return;
        }
        if (that.olmap.distinguish) {
          // 进行识别查询
          that.distinFun(evt);
          return;
        }
        var pixel = that.map.getEventPixel(evt.originalEvent);
        let featureObj = that.map.forEachFeatureAtPixel(pixel, feature => {
          return feature;
        });
        if (featureObj && featureObj.id_) {
          var arrData = that.mapPointsAll.filter(item => item.tableId == featureObj.id_);
          if (arrData.length > 0) {
            that.PopWinFea(arrData[0]); //弹出气泡的方法
          }
        }
      }),
        // 地图的缩放事件
        this.map.on('moveend', function(e) {
          var zoom = that.map.getView().getZoom();
          that.zoomNumber = zoom;
        });
    },
    /**
     * 地图弹出框(指定要素)
     * @param {object} [map] -地图组件
     * @param {object} [fea] -查询的要素信息
     */
    PopWinFea(feaData) {
      
      this.selectFeaData = feaData;
      this.olmap.getView().animate({
        center: [feaData.longitude, feaData.latitude],
        duration: 2000,
        zoom: 10,
        easing: this.$olmap.easing.Linear,
      });
      var coordinate = [Number(feaData.longitude), Number(feaData.latitude)]; //气泡的位置
      var titles = '基本信息';
      var imgStr = '';
      var imgArr = [];
      if (feaData.imgUrls) {
        if (feaData.imgUrls.indexOf(',') != -1) {
          imgArr = feaData.imgUrls.split(',');
        } else {
          imgArr.push(feaData.imgUrls);
        }
      }
      this.propImgArr = imgArr;
      imgArr.forEach((it, i) => {
        imgStr += `<li class="lisImg" onclick="previewImg(${i})">
          <img src='${it}' alt="" class="imgCodeCal"/>
        </li>`;
      });
      var tbHtml = '';
      tbHtml += `<div class='spInfo ivu-table-wrapper' style='height: 240px;position:relative;'><div  class='spAllinfo ivu-table ivu-table-default ivu-table-border'>
          <div class="titleCon">资源名称:${feaData.monomerName}</div>
          <div class="contentLis">
            <div class="popTitle">景 点 等 级:</div>
            <div class="popConText">${feaData.maybeGrade}</div>
          </div>
          <div class="contentLis">
            <div class="popTitle">是否新发现:</div>
            <div class="popConText">${feaData.newFind && feaData.newFind == 1 ? '是' : '否'}</div>
          </div>
          <div class="contentLis">
            <div class="popTitle">景 点 位 置:</div>
            <div class="popConText">${feaData.administrativeLocation}</div>
          </div>
          <ul class="imgcal">
            ${imgStr}
          </ul>
        </div>`;
      var TXTHTML = `<div class='bottom_btn' style='position: absolute;bottom: 0px;right: 0px;z-index:666;'>
        <div onclick='goDetail("${feaData.id}")' style='height:30px;line-height:35px;'>查看详情>></div>
      </div>`;
      tbHtml += TXTHTML;
      this.map.zxClosePops();
      this.PopWin(this.map, {
        center: coordinate,
        content: tbHtml,
        title: titles,
      });
    },
    /*
     *@description: 点击预览图片
     *@author: qqjuanqq
     *@date: 2023-06-30 10:55:44
     *@version: V1.0.0
     */
    previewImg(index) {
      this.imagesArr = [];
      this.imagesArr.push(this.propImgArr[index]);
      const viewer = this.$el.querySelector('.images').$viewer;
      viewer.show();
    },
    /**
     * 进行识别查询(指定要素)
     * @param {object} [map] -地图组件  工具条属性查询事件
     * @param {object} [fea] -查询的要素信息
     */
    distinFun(evt) {
      let that = this;
      var inx1 = 0;
      var slec = false;
      // 先判断图层是否勾选
      if (!this.olmap.selecLayers || this.olmap.selecLayers.length < 1) {
        this.olmap.distinLayer = null;
        return;
      }
      debugger;
      if (!this.olmap.distinLayer || this.olmap.distinLayer == null) {
        this.olmap.distinLayer = this.olmap.selecLayers[0];
      } else {
        // 之前选中的识别图层
        this.olmap.selecLayers.forEach(function(im, i) {
          // 判断当前识别的图层是否还在选中的=图层树中
          if (im.id === that.olmap.distinLayer.id) {
            inx1 = i;
            that.olmap.distinLayer = im;
            slec = true;
          }
        });

        if (!slec) {
          // 该图层已被移除，需重新赋值
          this.olmap.distinLayer = this.olmap.selecLayers[0];
          inx1 = 0;
        }
      }
      var layername = this.olmap.distinLayer; //选中的识别图层
      this.olmap.evt = evt;

      this.currentLayerInfo = this.olmap.distinLayer;
      if (!this.selectLayerData.tablename) {
        this.queryGeoServer(layername, evt, inx1);
      } else {
        this.queryDataBase(layername, evt, inx1);
      }
    },
    // 调用geoserver查询的接口 (点选查询的接口)
    async queryGeoServer(args, evt, inx) {
      var proj = appConfig.map.proj.split(':');
      if (!args || !args.url || args == null) return;
      if (!evt.coordinate || evt.coordinate.length < 1) return;
      var postData = {};
      var outFields = '*';
      postData.geometry = `INTERSECTS(the_geom, POINT(${evt.coordinate[0] +
        ' ' +
        evt.coordinate[1]}))`; //点查询的过滤条件
      postData.geometryType = 'esriGeometryPoint';
      if (this.configMap.distinRadius && this.configMap.distinRadius !== 0) {
        //点查询增加缓冲半径
        postData.geometry = `WITHIN(the_geom,buffer(POINT(${evt.coordinate[0]}%${evt.coordinate[1]}),${this.configMap.distinRadius}))`;
      }
      var that = this;
      postData.TypeName = args.layername;
      postData.SrsName = appConfig.map.proj;
      postData.startIndex = 0;
      postData.maxFeatures = 10;
      postData.CqlFilter = postData.geometry;
      var pjsonResult = await that.publicMethod.geoServerQuery(args.urlL, postData, this.$olmap);
      if (pjsonResult && pjsonResult.featureArr.length > 0) {
        that.publicMethod.addFeatures(that.olmap.zxQueryLayer, pjsonResult.featureArr);
      } else {
        that.publicMethod.clearFeatures(that.olmap.zxQueryLayer);
      }
    },
    //调取数据库查询接口
    queryDataBase(args, evt, inx) {
      var point = this.$turf.point([evt.coordinate[0], evt.coordinate[1]]);
      var buffered = this.$turf.buffer(point, 0.003, { units: 'degrees' }); //度
      let coordinates = [buffered.geometry.coordinates]; //点查询的过滤条件
      let geometriesParams = {
        type: 'MultiPolygon',
        coordinates: coordinates,
      };
      var params = {
        sr: '4326',
        type: '2',
        pageSize: 10,
        pageNum: 0,
        queryParam: '',
        indicate: this.selectLayerData.tablename,
        geometriesParams: JSON.stringify(geometriesParams),
      };
      let that = this;
      // http://192.168.1.113:8889/geoserverplugin/wps/getGeoserverQuery
      $.ajax({
        type: 'post',
        url: '/zituSpace/wps/getGeoserverQuery',
        // dataType: 'json',
        contentType: 'application/json; charset=UTF-8',
        data: JSON.stringify(params),
        success: function(res) {
          if (res.code == 200 && res.success) {
            let featureArr = [];
            if (res.result.features && res.result.features.length > 0) {
              res.result.features.forEach((item, index) => {
                var geojson_format = new that.$olmap.format.GeoJSON();
                let featureObj = geojson_format.readFeature(item.geometry);
                featureObj.values_ = Object.assign(featureObj.values_, item.properties);
                featureArr.push(featureObj);
              });
            }
            if (featureArr.length > 0) {
              that.publicMethod.addFeatures(that.olmap.zxQueryLayer, featureArr);
            } else {
              that.publicMethod.clearFeatures(that.olmap.zxQueryLayer);
            }
          }
        },
        error: function(e) {},
      });
    },
    getdatachange(data) {
      var timestamp4 = '';
      var date = new Date(data);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = date.getDate() + ' ';
      // let h = date.getHours() + ':';
      // let m = date.getMinutes() + ':';
      // let s = date.getSeconds();
      // timestamp4 = Y+M+D+h+m+s;
      timestamp4 = Y + M + D;
      return timestamp4;
    },
    /**
     * 地图弹出框(指定要素)-pdf查看
     * @param {object} [map] -地图组件
     * @param {object} [fea] -查询的要素信息
     */
    /*
     *@description:
     *@author: Fengxy
     *@date: 2023-03-25 15:16:46
     *@version: V1.0.5
     */
    
    goDetail(e) {
      this.$layer.close(this.$layerIds);
      this.$layerIds = this.$layer.iframe({
        title: '查看详情',
        content: {
          content: detailItem, //传递的组件对象
          parent: this, //当前的vue对象
          data: {
            tableId: e,
          },
        },
        area: [1100 + 'px', '65vh'],
        maxmin: false,
        shade: false, //是否显示遮罩
        resize: false, //能否调整弹窗大小
        cancel: () => {
          //关闭弹窗事件
          // alert('关闭iframe')
        },
      });
    },
    //地图弹出框
    PopWin(map, options) {
      var _this = this;
      var div = $(`<div class="ol-popup">
			<div class='ol-popup-title'>    
				<span id="title">属性</span>
				<div  class="ol-popup-closer" ><i class="ivu-icon ivu-icon-md-close  ttt" style='color:#ffffff;font-size:16px'></i></div>
				</div>
  				<div class="popup-content" style="background: white"></div>
  			</div>`);
      $(map.getTargetElement()).append(div);
      this.target = div;
      div.find('.ol-popup-closer').click(function() {
        _this.close();
      });
      div.find('.popup-content').append(options.content);
      _this.centers = options.center;
      this.overlay = new this.$olmap.Overlay({
        element: div[0],
        autoPan: true,
        positioning: 'center-left',
        autoPanAnimation: {
          duration: 250,
        },
      });
      this.viewF = function() {
        _this.overlay.setPosition(_this.center);
        _this.map.addOverlay(_this.overlay);
      };
      this.show = function() {
        _this.overlay.setPosition(_this.centers);
        _this.map.addOverlay(_this.overlay);
      };
      this.close = function() {
        _this.map.removeOverlay(_this.overlay);
        var pops = _this.map.zxPops;
        if (pops && pops.indexOf(_this) >= 0) {
          pops.splice(pops.indexOf(_this), 1);
        }
      };
      this.map.zxClosePops();
      this.show();
      this.map.zxPops = this.map.zxPops || [];
      this.map.zxPops.push(this);
      //弹出框标题赋值
      $('#title').html(options.title);
      document.getElementsByClassName('ol-popup').style =
        'position: relative;background-color: #FFFFFF; filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); padding: 34px 0 15px 0px; border-radius: 5px;bottom: 12px;left: -265px;min-width: 280px; top: -260px;width: 360px;';
      document.getElementsByClassName('ol-popup-title').style =
        'position: absolute; top: 0px;background-color: #0099fa;height: 36px;width: 100%;';
    },
    /**
     * @author zt
     * @date 2020.1.7
     * @description 查用户信息
     */
    getUser() {
      let users = Cookies.get('accessToken');
      if (users) {
        let user = users;
        this.username = user;
      }
    },
    /**
     * @author
     * @description 天地图影像和矢量图层切换-显示影像图层
     */
    showimagelayer() {
      // $('#mapType')
      //   .find('.active')
      //   .removeClass('active');
      // $('.expand #mapType .earth').addClass('active');
      // this.baseMapLayer.setVisible(false);
      // this.baseMapImgLayer.setVisible(true);
      this.map.setMapType(BMapGLGL_SATELLITE_MAP);
    },
    /**
     * @author
     * @description 天地图影像和矢量图层切换-显示矢量图层
     */
    showvector() {
      // $('#mapType')
      //   .find('.active')
      //   .removeClass('active');
      // $('.expand #mapType .normal').addClass('active');
      // this.baseMapImgLayer.setVisible(false);
      // this.baseMapLayer.setVisible(true);
      this.map.setMapType(BMapGLGL_NORMAL_MAP);
    },
    /**
     * @author
     * @description 其他图层互相切换-未使用
     */
    showxzqlayer() {
      this.baseMapLayer.setVisible(false);
      this.imageLayer.setVisible(false);
      this.markLayer.setVisible(false);
    },

    showswitchmap() {
      $('#mapType-wrapper').addClass('expand');
    },
    switchmap() {
      $('#mapType-wrapper').removeClass('expand');
    },
    cancelexport1() {
      this.mideaModalVisible = false;
    },
    // 文件上传之前
    handleUpload1(file) {
      // 文件上传之前的钩子
      let that = this;
      // 判断文件是否存在
      if (this.mideaInfo.length > 0) {
        // 返回一个Promise来阻止上传。
        return new Promise(function(resolve, reject) {
          that.$Modal.confirm({
            title: '确认替换',
            // 记得确认修改此处
            content: '当前pdf已存在，确定要替换吗？',
            onOk: () => {
              // 删除

              // that.uploadData.id = that.mideaInfo[0].id;
              resolve();
              that.loading = true;
              // that.loading = true;
            },
            onCancel: () => {
              reject();
            },
          });
        });
      } else {
        that.loading = true;
      }
    },
    async getmeideaList() {
      let res = await findListFileBySys({
        layerId: this.DrawingAndDocumentManagementId,
        fileFieldId: this.DrawingAndDocumentManagementFileId,
      });
      this.mideaInfo = res.result;
    },
    async uploadSuccess23(res, file) {
      //上传成功
      // 判断是否上传失败
      this.loading = false;
      if (res && res.code == 500) {
        this.$Message.info(res.message ? res.message : '上传失败');
        return;
      }
      let params = {
        layerId: this.DrawingAndDocumentManagementId,
        fileFieldId: this.DrawingAndDocumentManagementFileId,
        fileId: res.result.id,
      };
      let data = await insertArchivesManage(params);
      if (data.code == 200) {
        this.getmeideaList();
      }
    },
    handleFormatError2(file) {
      this.$Message.info('文件格式不正确,请重新选择');
    },
    uploadError(error, file) {
      //上传失败
      this.loading = false;
      this.$Message.info(error);
    },
    // 多媒体删除
    remove_midea(e) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '您确认要删除所选的数据?',
        mask: false,
        onOk: () => {
          var FeatureServer =
            this.currentLayerInfo.urlL.split('/FeatureServer')[0] + '/FeatureServer';
          let param = {
            attributes: this.feaData,
            layerId: this.currentLayerInfo.layerId ? this.currentLayerInfo.layerId : 0, //图层的id
            restUrl: FeatureServer, //图层服务的地址
            // id: e.id, //文件id
            field: this.pdfField,
          };

          deletemidea({ paramStr: JSON.stringify(param) }).then(res => {
            if (res.success === true) {
              this.$Message.success('删除成功');

              this.getmeideaList();

              if (!this.olmap.distinguish) {
                this.$emit('page_map', 1);
              }
            }
          });
        },
      });
    },
    // 多媒体下载
    showInfo_midea(e) {
      let globalMediaServerUrl = this.uploadConfig + '/media/pdf/';
      var url = globalMediaServerUrl + e.name;
      window.open(url);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mapbase/OlBaseMap.js